
import { Component, Vue } from "vue-property-decorator";
import GamesTable from "../components/Games/GamesTable.vue";
import ProgressDialog from "../components/Base/ProgressDialog.vue";
import ViewGame from "../components/Compose/ViewGame.vue";
import { Game } from "@/models/Game";
import { City } from "@/models/City";

@Component({
  components: { GamesTable, ViewGame, ProgressDialog },
})
class Compose extends Vue {
  showGame = false;
  gameData = {} as Game;

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  created(): void {
    this.$store.commit("authenication/setNavTab", 3);
  }
  handleGameSelection(row: any): void {
    if (this.gameData !== row) {
      this.$bvModal.show("team-modal-spinner");
      this.showGame = true;
      this.gameData = row;
      this.$store.dispatch("cityStore/getSingleCity", this.gameData.city);
      this.$store.dispatch("gameStore/getSeason", {
        gameType: this.gameData.gt_uid,
        seasonUid: this.gameData.seas_uid,
      });
      this;
      if (this.gameData.gt_uid == "quest") {
        this.$store.commit("mapPoiStore/setQuestMapPoi", []);
        this.$store.commit("questStore/setQuest", []);
        this.$store.dispatch("questStore/getQuestForGame", this.gameData.key);
        this.$store
          .dispatch("mapPoiStore/getQuestMapPoiForGame", this.gameData.key)
          .then(() => {
            setTimeout(() => {
              this.$bvModal.hide("team-modal-spinner");
            }, 750);
          });
      } else {
        this.$store.commit("mapPoiStore/setMapPoi", []);
        this.$store
          .dispatch("mapPoiStore/getMapPoiForGame", this.gameData.key)
          .then(() => {
            setTimeout(() => {
              this.$bvModal.hide("team-modal-spinner");
            }, 750);
          });
      }
    }
  }
  get isEditing(): boolean {
    return this.$store.state.gameStore.isGameEditing;
  }
  closeDialogLanguage(): void {
    this.showGame = false;
  }
}

export default Compose;
